import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import {PageTop, TitleH1, Title, SidebarNews, InfoBlock, Main, Content, Row, Col2 } from '../layouts/layouts'
import SideBarRight from '../layouts/SideBarRight'
import Gallery from '../layouts/gallery'

import thumb1 from '../assets/iltasanomat29032008-140x140-8274.jpg'
import thumb2 from '../assets/pohjalainenyrittaja-140x140-4656.jpg'
import thumb3 from '../assets/pohjalainenyrittaja2-140x140-5875.jpg'
import thumb4 from '../assets/iltasanomat05012008kuva1-140x140-2210__.jpg'
import thumb5 from '../assets/iltasanomat05012008kuva2-140x140-3651.jpg'
import thumb6 from '../assets/jp-kunnallissanomat-140x140-6459.jpg'
import thumb7 from '../assets/HakupaallaLehdenJuttu-140x140-7761.jpg'
import thumb8 from '../assets/puhumalla_parempaa_seksia-140x140-6371.jpg'
import img1 from '../assets/iltasanomat29032008.jpg'
import img2 from '../assets/pohjalainenyrittaja.jpg'
import img3 from '../assets/pohjalainenyrittaja2.jpg'
import img4 from '../assets/iltasanomat05012008kuva1.jpg'
import img5 from '../assets/iltasanomat05012008kuva2.jpg'
import img6 from '../assets/jp-kunnallissanomat.jpg'
import img7 from '../assets/HakupaallaLehdenJuttu.jpg'
import img8 from '../assets/puhumalla_parempaa_seksia.jpg'

class Psykoterapia extends React.Component {

  render() {
    return (
      <div>
        <Helmet>
          <title>Kirsti Louko - Seksuaalineuvonta</title>
        </Helmet>
        <PageTop>
          <TitleH1>SEKSUAALINEUVONTA</TitleH1>
          <p>Seksuaalineuvonta on neuvontaa ja ohjausta, ongelmien ja kysymysten selvittelyä ja ratkaisuja.Tavoitteena on, että ihminen kokee oman ja toisen sukupuolisuuden luonnollisena osana elämää. ​</p>
        </PageTop>
        <Content>
          <SideBarRight />
          <Main column>
            <p>Seksuaalineuvonnassa käsitellään sukupuolisuuden, sukupuolisuhteiden ja seksielämän erilaisia häiriöitä. Seksuaalisia häiriöitä ovat esim. sukupuolinen haluttomuus, kiihottumishäiriöt, erektiohäiriöt ja orgasmivaikeudet. Seksuaalineuvonnassa EI koskaan harrasteta seksiä. Seksuaalineuvoja ei kosketa asiakasta seksuaalisesti, eikä päinvastoin.</p>
            <p>Valitettavasti puhelinneuvontaan minulla ei ole mahdollisuutta, vaan pyydän &nbsp;
            <Link to="/yhteystiedot">varaamaan ajan.</Link>
            </p>

              <Title small>JULKAISTUJA LEHTIARTIKKELEITANI AIHEESTA</Title>

            <Row>

                <Gallery
                  images={[
                    { src: `${img1}`,
                      thumb: `${thumb1}`,
                    },
                    { src: `${img2}`,
                      thumb: `${thumb2}`,
                    },
                    { src: `${img3}`,
                      thumb: `${thumb3}`,
                    },
                    { src: `${img4}`,
                      thumb: `${thumb4}`,
                    },
                    { src: `${img5}`,
                      thumb: `${thumb5}`,
                    },
                    { src: `${img6}`,
                      thumb: `${thumb6}`,
                    },
                    { src: `${img7}`,
                      thumb: `${thumb7}`,
                    },
                    { src: `${img8}`,
                      thumb: `${thumb8}`,
                    },
                  ]}
                />


            </Row>
          </Main>
        </Content>

      </div>
    )
  }
}

export default Psykoterapia;



// WEBPACK FOOTER //
// ./src/pages/seksuaalineuvonta.js